<template>
  <section class="el-column">
    <div class="el-column__navbar">
      <pagarme-logo-green v-if="showLogo && theme === 'pagarme' && color === 'primary'" />
      <pagarme-logo v-else-if="showLogo && theme === 'pagarme' && color === 'secondary'"/>
      <mundi-logo v-else-if="showLogo"/>
    </div>
    <div class="el-bounds _narrow">
      <div class="emd-text _align_center" v-if="theme === 'pagarme'">
        <error-404-pgm v-if="code === 404 || code === 403" @ctaClicked="clearStorage"/>
        <error-500-pgm v-else @ctaClicked="refreshPage" />
      </div>
      <div class="emd-text _align_center" v-else>
        <error-404 v-if="code === 404 || code === 403" @ctaClicked="clearStorage"/>
        <error-500 v-else @ctaClicked="refreshPage" />
      </div>
    </div>
  </section>
</template>
<script>
import EmdPagarmeLogo from '../../../emerald/atoms/emdPagarmeLogo/EmdPagarmeLogo.vue'
import EmdPagarmeLogoGreen from '../../../emerald/atoms/emdPagarmeLogoGreen/EmdPagarmeLogoGreen.vue'
import EmdMundiLogoColored from '../../../emerald/atoms/emdMundiLogoColored/EmdMundiLogoColored.vue'
import Error404 from './childrenComponents/mundipagg/Error404.vue'
import Error500 from './childrenComponents/mundipagg/Error500.vue'
import Error404Pgm from './childrenComponents/pagarme/Error404Pgm.vue'
import Error500Pgm from './childrenComponents/pagarme/Error500Pgm.vue'

export default {
  name: 'GlobalError',
  components: {
    MundiLogo: EmdMundiLogoColored,
    PagarmeLogo: EmdPagarmeLogo,
    PagarmeLogoGreen: EmdPagarmeLogoGreen,
    Error404,
    Error500,
    Error404Pgm,
    Error500Pgm
  },
  methods: {
    clearStorage () {
      window.location.assign('/')
    },
    refreshPage () { this.$router.go() }
  },
  props: {
    showLogo: {
      type: Boolean,
      default: true
    },
    code: {
      type: Number,
      default: 500
    },
    theme: {
      type: String,
      default: 'mundipagg',
      validator: (value) => {
        return ['mundipagg', 'pagarme', 'jpmorgan', 'digital'].includes(value)
      }
    },
    color: {
      type: String,
      default: 'primary',
      validator: (value) => {
        return ['primary', 'secondary'].includes(value)
      }

    }
  }
}
</script>
